import { AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { EventTransportService } from '@services/event-transport/event-transport.service';
import QrScanner from 'qr-scanner';
export interface IOnScan
{
    result: string;
    data?: string;
}

@Component({
    selector: 'app-qr-scanner',
    templateUrl: './qr-scanner.component.html',
    styleUrls: [ './qr-scanner.component.scss' ],
})
export class QrScannerComponent implements OnInit, AfterViewInit, OnDestroy
{
    @Output('scan') onScan: EventEmitter<IOnScan> = new EventEmitter();

    @ViewChild('qrReaderEl') qrReaderEl: ElementRef;

    public cameraNotFound = false;

    private qrScanner: QrScanner;

    constructor(
        private eventTransport: EventTransportService,
    ) { }

    public ngOnInit(): void { }

    public async ngAfterViewInit(): Promise<void>
    {
        try
        {
            const video: HTMLVideoElement = this.qrReaderEl.nativeElement;
            this.qrScanner = new QrScanner(
                video,
                (result): void =>
                {
                    console.log(result);
                    this.onScan.emit({
                        result: 'success',
                        data: result.data,
                    });
                },
                {
                    preferredCamera: 'environment',
                    highlightScanRegion: true
                }
            );

            this.qrScanner.setInversionMode('both');

            await this.qrScanner.start();
        }
        catch (e) 
        {
            console.error(e);
            this.cameraNotFound = true;
        }
    }

    public async ngOnDestroy(): Promise<void>
    {
        if (this.qrScanner)
        {
            this.qrScanner.stop();
            this.qrScanner.destroy();
        }
    }

    private getQR(): void
    {

    }

    public closeQr()
    {
        this.onScan.emit({
            result: 'rejected',
            data: ''
        });
    }
}
